import React from 'react';
import { Link } from 'react-router-dom';
import { Youtube, Instagram, Linkedin } from 'lucide-react';

const YOUTUBE = 'https://www.youtube.com/@AIRevolutionDigestPodcast';
const SPOTIFY = 'https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit';
const APPLE = 'https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192';
const LINKEDIN = 'https://www.linkedin.com/newsletters/7106830033050079232/';

const Footer = () => (
  <footer className="relative py-16 px-4 sm:px-6 border-t border-white/5">
    <div className="max-w-7xl mx-auto">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo.png" alt="AI Revolution Digest" className="h-10 w-10" />
            <h3 className="font-bold text-lg">AI Revolution Digest</h3>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed">
            Your unfair advantage in the age of AI. Insights from CEOs, innovators, and industry leaders redefining business and technology.
          </p>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-gray-300">Listen</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={SPOTIFY} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#EF5B5B] smooth">Spotify</a></li>
            <li><a href={APPLE} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#EF5B5B] smooth">Apple Podcasts</a></li>
            <li><a href={YOUTUBE} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#EF5B5B] smooth">YouTube</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-gray-300">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/episodes" className="text-gray-400 hover:text-[#EF5B5B] smooth">All Episodes</Link></li>
            <li><Link to="/apply" className="text-gray-400 hover:text-[#EF5B5B] smooth">Apply to Speak</Link></li>
            <li><Link to="/about" className="text-gray-400 hover:text-[#EF5B5B] smooth">About Jeslyn</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-gray-300">Connect</h4>
          <div className="flex gap-4">
            <a href={YOUTUBE} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-[#EF5B5B]/20 hover:border-[#EF5B5B] smooth border border-white/5"><Youtube className="w-5 h-5" /></a>
            <a href={LINKEDIN} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-[#EF5B5B]/20 hover:border-[#EF5B5B] smooth border border-white/5"><Linkedin className="w-5 h-5" /></a>
            <a href="https://www.instagram.com/ai_revolution_digest_podcast_" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-[#EF5B5B]/20 hover:border-[#EF5B5B] smooth border border-white/5"><Instagram className="w-5 h-5" /></a>
          </div>
        </div>
      </div>

      <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
        <p className="text-sm text-gray-500">© 2025 AI Revolution Digest · Hosted by Jeslyn Allison Rancap Jerota</p>
        <Link to="/admin" className="text-xs text-gray-600 hover:text-gray-400 smooth">Admin</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
